import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { landingGroups, landingPaths, categoryUrl } from "./landingData";
import { supabase } from "../lib/supabase";
import { versionedImageUrl } from "../lib/imageUrl";
import "./VisualNavigation.css";
function Branches({ parent, paths }: { parent: string; paths: string[] }) {
  return (
    <>
      {paths
        .filter(
          (p) =>
            p.startsWith(parent + "/") &&
            p.split("/").length === parent.split("/").length + 1,
        )
        .map((p) =>
          paths.some((c) => c.startsWith(p + "/")) ? (
            <details key={p}>
              <summary>{p.split("/").at(-1)}</summary>
              <div className="vn-children">
                <Link to={categoryUrl(p)}>Ver todos</Link>
                <Branches parent={p} paths={paths} />
              </div>
            </details>
          ) : (
            <Link key={p} to={categoryUrl(p)}>
              {p.split("/").at(-1)}
            </Link>
          ),
        )}
    </>
  );
}
export function VisualNavigation() {
  const [open, setOpen] = useState(false);
  const [paths, setPaths] = useState(landingPaths);
  const ref = useRef<HTMLElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    let active = true;
    supabase.rpc("nuled_category_tree").then(({ data }) => {
      if (active && data?.length)
        setPaths((data as { path: string }[]).map((x) => x.path));
    });
    return () => {
      active = false;
    };
  }, []);
  useEffect(() => {
    const close = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);
  const discoveredTops = [...new Set(paths.map((p) => p.split("/")[0]))];
  const tops = ["COMPOSE", ...discoveredTops.filter((name) => name !== "COMPOSE")];
  return (
    <nav
      className="visual-nav"
      ref={ref}
      onMouseLeave={() => setOpen(false)}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          setOpen(false);
          trigger.current?.focus();
        }
      }}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false);
      }}
    >
      <div className="vn-links">
        <Link className="vn-compose" to="/compose" onMouseEnter={() => setOpen(false)}>
          COMPOSE <small>Build your light</small>
        </Link>
        <Link className="vn-track" to="/arma-tu-riel" onMouseEnter={() => setOpen(false)}>
          ARMA TU RIEL <small>5 · 10 · 20</small>
        </Link>
        <button
          ref={trigger}
          aria-expanded={open}
          aria-controls="visual-categories"
          onMouseEnter={() => setOpen(true)}
          onClick={() => setOpen((v) => !v)}
          onKeyDown={(e) => {
            if (e.key === "ArrowDown") {
              e.preventDefault();
              setOpen(true);
            }
          }}
        >
          Luminarias ⌄
        </button>
        <a href="/#espacios" onMouseEnter={() => setOpen(false)}>
          Por espacio
        </a>
        <a href="/#seleccion" onMouseEnter={() => setOpen(false)}>
          Diseña con luz
        </a>
        <Link to="/lutron" onMouseEnter={() => setOpen(false)}>
          Control Lutron
        </Link>
        <a href="/#asesoria" onMouseEnter={() => setOpen(false)}>
          Asesoría
        </a>
        <Link className="vn-dealer" to="/distribuidor">
          Vuélvete distribuidor
        </Link>
      </div>
      {open && (
        <div id="visual-categories" className="vn-panel">
          <div className="vn-caption">
            EXPLORA NUESTRAS LUMINARIAS
            <button
              aria-label="Cerrar menú"
              onClick={() => {
                setOpen(false);
                trigger.current?.focus();
              }}
            >
              ×
            </button>
          </div>
          <div className="vn-grid">
            {tops.map((name) => {
              if (name === "COMPOSE") {
                return (
                  <section
                    key={name}
                    onClick={(e) => {
                      if ((e.target as HTMLElement).closest("a")) setOpen(false);
                    }}
                  >
                    <Link className="vn-photo" to="/compose">
                      <img src={versionedImageUrl('/compose/a.png')} alt="COMPOSE" />
                    </Link>
                    <h3><Link to="/compose">COMPOSE</Link></h3>
                    <Link to="/compose#configurador">Configurar sistema</Link>
                    <Link to={categoryUrl('COMPOSE')}>Ver módulos y bases</Link>
                  </section>
                );
              }
              const group = landingGroups.find((g) => g.name === name);
              return (
                <section
                  key={name}
                  onClick={(e) => {
                    if ((e.target as HTMLElement).closest("a")) setOpen(false);
                  }}
                >
                  {group && (
                    <Link className="vn-photo" to={categoryUrl(name)}>
                      <img src={versionedImageUrl(group.slides[0].url)} alt={name} />
                    </Link>
                  )}
                  <h3>
                    <Link to={categoryUrl(name)}>{name}</Link>
                  </h3>
                  <Branches parent={name} paths={paths} />
                </section>
              );
            })}
          </div>
          <div className="vn-bottom">
            <span>Encuentra la familia. Elige sus variantes.</span>
            <Link to="/catalogo">Ver todo el catálogo</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
